import { Component, HostBinding, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ScrollToTop } from '../utils/functions';
import { Location } from '@angular/common';
import { AccountService } from '../services/account.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss'],
})
export class AccountComponent implements OnInit {
  btnText = 'signup';
  downTimeNotice;
  @HostBinding('class.mobile') isMobileLayout;
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.isMobileLayout = event.target.innerWidth <= 991;
  }
  constructor(private router: Router, private location: Location, private accountservice: AccountService, private dialogRef: MatDialog) {
    localStorage.removeItem('lang');
    location.onUrlChange((url) => {
      this.btnText = (url.indexOf('signup') > -1 && 'login') || 'signup';
    });
  }

  async ngOnInit() {
    console.log('AccountComponent ngOnInit, close all dialogs');
    this.dialogRef.closeAll();

    ScrollToTop();

    this.isMobileLayout = window.innerWidth <= 991;
    try {
      this.downTimeNotice = await this.accountservice.downTimeNotice();
    } catch (e) {}
  }
}
